<template>
  <div>
    <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
    >
    </EmailGrabberPopup>
    <section
      class="mx-[25px] mt-[50px] rounded-[19px] rounded-b-none bg-[#ebfaf6a9] md:rounded-t-[60px] lg:mx-auto lg:flex xl:h-[900px] xl:w-[1300px] pt-[50px] lg:pt-[110px] pb-10 px-[30px] lg:px-[80px]"
    >
      <div class="max-w-[1200px] lg:flex justify-between mx-auto">
        <div class="lg:w-[450px]">
          <img
            loading="lazy"
            class=""
            :src="$filters.media_path('/images/green-the-platform-icon.svg')"
            alt=""
          />
          <div
            id="text_interface"
            class="text-sm font-bold tracking-wide text-[#27AE60] mt-[50px]"
          >
            THE PLATFORM
          </div>

          <!-- DYNAMIC CONTENT TEXT -->

          <!-- HOMEBASE TEXT 1 -->

          <div
            class=""
            v-bind:class="{ hidden: openTab !== 1, block: openTab === 1 }"
          >
            <h2
              class="top-full mt-[25px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Funnel subs to the future of social marketing.
            </h2>
            <p
              class="mt-[40px] mb-10 text-sm font-normal leading-[25px] text-[#292d34] xl:max-w-[440px]"
            >
              Easily drive traffic from your social media accounts to your site
              with exclusive content that you control. Own the data of your
              subscribers instead of social media owning you.
            </p>
          </div>

          <!-- CHECKOUT CART TEXT 2 -->

          <div
            class=""
            v-bind:class="{ hidden: openTab !== 2, block: openTab === 2 }"
          >
            <h2
              class="top-full mt-[25px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Sell more with a full checkout flow and upsells.
            </h2>
            <p
              class="mt-[40px] mb-10 text-sm font-normal leading-[25px] text-[#292d34] xl:max-w-[440px]"
            >
              Monetize all followers, subscribers, and customers with flexible
              terms, and opportune upsells, OR integrate with your current 3rd
              party checkout and payment processor.
            </p>
          </div>

          <!-- QUIZZES TEXT 3 -->

          <div
            class=""
            v-bind:class="{ hidden: openTab !== 3, block: openTab === 3 }"
          >
            <h2
              class="top-full mt-[25px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Create quizzes for engagement or auto coaching.
            </h2>
            <p
              class="mt-[40px] mb-10 text-sm font-normal leading-[25px] text-[#292d34] xl:max-w-[440px]"
            >
              Customize your Platform quizzes to automate many coaching
              questions. Members can get individualized coaching without your
              time.
            </p>
          </div>

          <!-- QUIZZES TEXT 4 -->

          <div
            class=""
            v-bind:class="{ hidden: openTab !== 4, block: openTab === 4 }"
          >
            <h2
              class="top-full mt-[25px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Send leads to your favorite CRM.
            </h2>
            <p
              class="mt-[40px] mb-10 text-sm font-normal leading-[25px] text-[#292d34] xl:max-w-[440px]"
            >
              Sync your new members and subscriber to be added to email
              automations you have setup in your autoresponder.
            </p>
          </div>

          <!-- DYNAMIC CONTENT TEXT END -->

          <!-- THE PLATFORM TABS DESKTOP -->

          <div class="hidden lg:block">
            <!-- TAB ROW ONE -->

            <div class="tab-row-1 flex justify-between">
              <!-- TAB ONE -->

              <div
                class="flex pr-5 cursor-pointer lg:w-[200px]"
                v-on:click="toggleTabs(1)"
                v-bind:class="{
                  'hover:ease-in': openTab !== 1,
                  '': openTab === 1
                }"
              >
                <div
                  class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
                  v-bind:class="{
                    'text-[#292d34] bg-white': openTab !== 1,
                    'text-white bg-[#27AE60]': openTab === 1
                  }"
                >
                  <p class="font-bold text-[16px]">01</p>
                </div>
                <p
                  class="lg:text-sm text-xs font-semibold my-auto"
                  v-bind:class="{
                    'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 1,
                    'text-[#292d34]': openTab === 1
                  }"
                >
                  Homebase
                </p>
              </div>

              <!-- TAB TWO -->

              <div
                class="flex pr-5 cursor-pointer lg:w-[200px]"
                v-on:click="toggleTabs(2)"
                v-bind:class="{
                  'hover:ease-in': openTab !== 2,
                  '': openTab === 2
                }"
              >
                <div
                  class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
                  v-bind:class="{
                    'text-[#292d34] bg-white': openTab !== 2,
                    'text-white bg-[#27AE60]': openTab === 2
                  }"
                >
                  <p class="font-bold text-[16px]">02</p>
                </div>
                <p
                  class="lg:text-sm text-xs font-semibold my-auto"
                  v-bind:class="{
                    'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 2,
                    'text-[#292d34]': openTab === 2
                  }"
                >
                  Checkout Cart
                </p>
              </div>
            </div>

            <!-- TAB ROW ONE -->

            <div class="tab-row-2 flex mt-[25px] justify-between">
              <!-- TAB THREE -->

              <div
                class="flex pr-5 cursor-pointer lg:w-[200px]"
                v-on:click="toggleTabs(3)"
                v-bind:class="{
                  'hover:ease-in': openTab !== 3,
                  '': openTab === 3
                }"
              >
                <div
                  class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
                  v-bind:class="{
                    'text-[#292d34] bg-white': openTab !== 3,
                    'text-white bg-[#27AE60]': openTab === 3
                  }"
                >
                  <p class="font-bold text-[16px]">03</p>
                </div>
                <p
                  class="lg:text-sm text-xs font-semibold my-auto"
                  v-bind:class="{
                    'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 3,
                    'text-[#292d34]': openTab === 3
                  }"
                >
                  Quizzes
                </p>
              </div>

              <!-- TAB FOUR -->

              <div
                class="flex pr-5 cursor-pointer lg:w-[200px]"
                v-on:click="toggleTabs(4)"
                v-bind:class="{
                  'hover:ease-in': openTab !== 4,
                  '': openTab === 4
                }"
              >
                <div
                  class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
                  v-bind:class="{
                    'text-[#292d34] bg-white': openTab !== 4,
                    'text-white bg-[#27AE60]': openTab === 4
                  }"
                >
                  <p class="font-bold text-[16px]">04</p>
                </div>
                <p
                  class="lg:text-sm text-xs font-semibold my-auto"
                  v-bind:class="{
                    'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 4,
                    'text-[#292d34]': openTab === 4
                  }"
                >
                  Integrations
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- DYNAMIC VISUAL CONTENT  -->

        <div
          class="lg:w-[660px]"
          v-bind:class="{ block: openTab !== 1, hidden: openTab === 4 }"
        >
          <!-- HOMEBASE VIDEO 1 -->

          <video
            class="mx-auto xl:absolute xl:w-[800px] xl:translate-x-[-10%] xl:translate-y-[35%] aspect-auto"
            v-bind:class="{ hidden: openTab !== 1, block: openTab === 1 }"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/social-media-marketing-to-membership-site-monetization-for-contuintiy-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>

          <!-- CHECKOUT VIDEO 2 -->

          <video
            class="mx-auto xl:absolute xl:w-[650px] xl:translate-x-[10%] xl:translate-y-[35%] aspect-auto rounded-[10px] lg:rounded-[20px] shadow-2xl"
            v-bind:class="{ hidden: openTab !== 2, block: openTab === 2 }"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="$filters.media_path('/videos/checkout-page-com.mp4')"
              type="video/mp4"
            />
          </video>

          <!-- QUIZZES VIDEO 3 -->

          <video
            class="mx-auto xl:absolute xl:w-[650px] xl:translate-x-[10%] xl:translate-y-[35%] aspect-auto rounded-[10px] lg:rounded-[20px] shadow-2xl"
            v-bind:class="{ hidden: openTab !== 3, block: openTab === 3 }"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/membership-site-coaching-quizzes-quiz-builder-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>

        <!-- INTEGRATIONS MATRIX 4 -->

        <div
          class="lg:w-[660px] px-auto justify-center mt-[40px]"
          v-bind:class="{ hidden: openTab !== 4, block: openTab === 4 }"
        >
          <ul class="flex w-full gap-[20px] mt-[20px] justify-center">
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path('/images/sendgrid-integrations-tiles.png')
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/mailchimp-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/sendinblue-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
          </ul>

          <ul class="flex w-full gap-[20px] mt-[20px] mx-auto justify-center">
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path('/images/drip-integrations-tiles.png')
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/getresponse-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
          </ul>

          <ul class="flex w-full gap-[20px] mt-[20px] justify-center">
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/constantcontact-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path('/images/aweber-integrations-tiles.png')
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/mailerlite-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
          </ul>

          <ul class="flex w-full gap-[20px] mt-[20px] mx-auto justify-center">
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path('/images/hubspot-integrations-tiles.png')
                "
                alt=""
              />
            </li>
            <li>
              <img
                loading=""
                class="lg:w-[175px] lg:h-[115px] hover:scale-[110%] hover:ease-in-out duration-700 hover:shadow-xl"
                :src="
                  $filters.media_path(
                    '/images/activecampaign-integrations-tiles.png'
                  )
                "
                alt=""
              />
            </li>
          </ul>
        </div>
      </div>

      <!-- THE PLATFORM TABS MOBILE -->

      <div class="mt-[40px] lg:hidden block">
        <!-- TAB ROW ONE -->

        <div class="tab-row-1 flex justify-between">
          <!-- TAB ONE -->

          <div
            class="flex pr-5 cursor-pointer lg:w-[200px]"
            v-on:click="toggleTabs(1)"
            v-bind:class="{ 'hover:ease-in': openTab !== 1, '': openTab === 1 }"
          >
            <div
              class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
              v-bind:class="{
                'text-[#292d34] bg-white': openTab !== 1,
                'text-white bg-[#27AE60]': openTab === 1
              }"
            >
              <p class="font-bold text-[16px]">01</p>
            </div>
            <p
              class="text-sm font-semibold my-auto"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 1,
                'text-[#292d34]': openTab === 1
              }"
            >
              Homebase
            </p>
          </div>

          <!-- TAB TWO -->

          <div
            class="flex pr-5 cursor-pointer lg:w-[200px]"
            v-on:click="toggleTabs(2)"
            v-bind:class="{ 'hover:ease-in': openTab !== 2, '': openTab === 2 }"
          >
            <div
              class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
              v-bind:class="{
                'text-[#292d34] bg-white': openTab !== 2,
                'text-white bg-[#27AE60]': openTab === 2
              }"
            >
              <p class="font-bold text-[16px]">02</p>
            </div>
            <p
              class="text-sm font-semibold my-auto"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 2,
                'text-[#292d34]': openTab === 2
              }"
            >
              Payments
            </p>
          </div>
        </div>

        <!-- TAB ROW TWO -->

        <div class="tab-row-2 flex mt-[25px] justify-between">
          <!-- TAB THREE -->

          <div
            class="flex pr-5 cursor-pointer lg:w-[200px]"
            v-on:click="toggleTabs(3)"
            v-bind:class="{ 'hover:ease-in': openTab !== 3, '': openTab === 3 }"
          >
            <div
              class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
              v-bind:class="{
                'text-[#292d34] bg-white': openTab !== 3,
                'text-white bg-[#27AE60]': openTab === 3
              }"
            >
              <p class="font-bold text-[16px]">03</p>
            </div>
            <p
              class="text-sm font-semibold my-auto"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 3,
                'text-[#292d34]': openTab === 3
              }"
            >
              Quizzes
            </p>
          </div>

          <!-- TAB FOUR -->

          <div
            class="flex pr-5 cursor-pointer lg:w-[200px]"
            v-on:click="toggleTabs(4)"
            v-bind:class="{ 'hover:ease-in': openTab !== 4, '': openTab === 4 }"
          >
            <div
              class="rounded-full w-[30px] h-[30px] text-center mr-[10px] pt-[4px]"
              v-bind:class="{
                'text-[#292d34] bg-white': openTab !== 4,
                'text-white bg-[#27AE60]': openTab === 4
              }"
            >
              <p class="font-bold text-[16px]">04</p>
            </div>
            <p
              class="text-sm font-semibold my-auto"
              v-bind:class="{
                'text-[#B9BEC7] hover:text-[#7c828d]': openTab !== 4,
                'text-[#292d34]': openTab === 4
              }"
            >
              Integrations
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- BOTTOM BUTTON BORDER -->

    <div
      class="mx-[25px] h-[63px] rounded-[19px] rounded-t-none bg-[#E6F8F3] pt-[11px] text-center md:rounded-b-[60px] lg:mx-auto xl:w-[1300px]"
    >
      <div
        class="mx-auto my-0 flex h-[42px] w-[142px] justify-center rounded-[9px] bg-transparent align-middle hover:ease-in-out hover:duration-500 hover:bg-white"
      >
        <!-- class="bg-[url('/img/arrow-right-blue.svg')] text-sm font-semibold text-[#292d34]" -->
        <button
          @click="toggleGrabber('free', null)"
          type="button"
          class="text-sm font-semibold text-[#292d34]"
        >
          Get Started
        </button>

        <img
          :src="$filters.media_path('/images/green-arrow-right.svg')"
          alt=""
          class="ml-2 w-[17px]"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'green-sectio'
};
</script>

<script setup>
import { ref } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const openTab = ref(1);
const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);
const toggleTabs = (tabNumber) => {
  openTab.value = tabNumber;
};

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};
</script>

<styles>
</styles>
